// import "splitting/dist/splitting.css";
// import "splitting/dist/splitting-cells.css";
// import Splitting from "splitting";

// import { section01 } from "./section01.js"
import { section02 } from "./section02.js"
import { section03 } from "./section03.js"
// import { section04 } from "./section04.js"
import { section05 } from "./section05.js"
import { section07 } from "./section07.js"
import { section08 } from "./section08.js"
import { section09 } from "./section09.js"
import { section10 } from "./section10.js"
import { section13 } from "./section13.js"
import { section14 } from "./section14.js"
import { section15 } from "./section15.js"
import { section16 } from "./section16.js"

// Splitting();

window.addEventListener("DOMContentLoaded", (event) => {
    let windowWidth = window.innerWidth
    let windowHeight = window.innerHeight
    window.addEventListener("resize", (event) => {
        windowWidth = window.innerWidth
        windowHeight = window.innerHeight
    })

    // section01() // Giant Text Animation
    section02() // Slice 2 - CREA ACI Logo
    section03() // Slice 3 - Website Laptop Section
    // section04() // Giant Text Animation
    section05() // Strategy Flow
    section07() // Living room Cards
    section08() // Slice 8 - Living Room Tablet
    section09() // Living Room Social
    section10() // Living Room Numbers
    section13() // REAL TIME Video
    section14() // REAL TIME Carousel
    section15() // REAL TIME Numbers
    section16() // REAL TIME Experiential
})
